import * as Types from "../../../apollo/graphql.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export type PublicPortfolioQueryVariables = Types.Exact<{
  slug: Types.Scalars["String"];
}>;

export type PublicPortfolioQuery = {
  publicPortfolio: {
    __typename: "Portfolio";
    id: string;
    title: string | null;
    bio: string | null;
    slug: string;
    status: Types.PortfolioStatus;
    curator: string | null;
    artistName: string | null;
    twitter: string | null;
    items: {
      __typename: "PortfolioItemsPaginated";
      edges: Array<{
        __typename: "PortfolioItem";
        id: string;
        name: string | null;
        collectionName: string | null;
        imageUrl: string;
        videoUrl: string | null;
        description: string | null;
        openSeaLink: boolean;
        collectionId: string | null;
        button: {
          __typename: "PortfolioItemButton";
          text: string | null;
          url: string;
        } | null;
        collectionInfo: {
          __typename: "CollectionInfo";
          address: string;
          chainId: number;
          standard: string;
          size: number | null;
          tokenId: string | null;
        };
      }>;
    };
  } | null;
};

export type PortfolioItemMetadataQueryVariables = Types.Exact<{
  itemId: Types.Scalars["String"];
  slug: Types.Scalars["String"];
}>;

export type PortfolioItemMetadataQuery = {
  getPortfolioItemMetadata: {
    __typename: "NftOnchainMetadata";
    imageOriginalUrlHttp: string | null;
  } | null;
};

export const PublicPortfolioDocument = gql`
  query PublicPortfolio($slug: String!) {
    publicPortfolio(slug: $slug) {
      id
      title
      bio
      slug
      status
      curator
      artistName
      twitter
      items {
        edges {
          id
          name
          collectionName
          imageUrl
          videoUrl
          description
          openSeaLink
          collectionId
          button {
            text
            url
          }
          collectionInfo {
            address
            chainId
            standard
            size
            tokenId
          }
        }
      }
    }
  }
`;

/**
 * __usePublicPortfolioQuery__
 *
 * To run a query within a React component, call `usePublicPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicPortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicPortfolioQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePublicPortfolioQuery(
  baseOptions: Apollo.QueryHookOptions<
    PublicPortfolioQuery,
    PublicPortfolioQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PublicPortfolioQuery, PublicPortfolioQueryVariables>(
    PublicPortfolioDocument,
    options
  );
}
export function usePublicPortfolioLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PublicPortfolioQuery,
    PublicPortfolioQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PublicPortfolioQuery,
    PublicPortfolioQueryVariables
  >(PublicPortfolioDocument, options);
}
export type PublicPortfolioQueryHookResult = ReturnType<
  typeof usePublicPortfolioQuery
>;
export type PublicPortfolioLazyQueryHookResult = ReturnType<
  typeof usePublicPortfolioLazyQuery
>;
export type PublicPortfolioQueryResult = Apollo.QueryResult<
  PublicPortfolioQuery,
  PublicPortfolioQueryVariables
>;
export const PortfolioItemMetadataDocument = gql`
  query PortfolioItemMetadata($itemId: String!, $slug: String!) {
    getPortfolioItemMetadata(itemId: $itemId, slug: $slug) {
      imageOriginalUrlHttp
    }
  }
`;

/**
 * __usePortfolioItemMetadataQuery__
 *
 * To run a query within a React component, call `usePortfolioItemMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfolioItemMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfolioItemMetadataQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePortfolioItemMetadataQuery(
  baseOptions: Apollo.QueryHookOptions<
    PortfolioItemMetadataQuery,
    PortfolioItemMetadataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PortfolioItemMetadataQuery,
    PortfolioItemMetadataQueryVariables
  >(PortfolioItemMetadataDocument, options);
}
export function usePortfolioItemMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PortfolioItemMetadataQuery,
    PortfolioItemMetadataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PortfolioItemMetadataQuery,
    PortfolioItemMetadataQueryVariables
  >(PortfolioItemMetadataDocument, options);
}
export type PortfolioItemMetadataQueryHookResult = ReturnType<
  typeof usePortfolioItemMetadataQuery
>;
export type PortfolioItemMetadataLazyQueryHookResult = ReturnType<
  typeof usePortfolioItemMetadataLazyQuery
>;
export type PortfolioItemMetadataQueryResult = Apollo.QueryResult<
  PortfolioItemMetadataQuery,
  PortfolioItemMetadataQueryVariables
>;
